import { Component, ViewContainerRef, ViewChild } from '@angular/core';

@Component({
  selector: 'el-windows-container',
  template: `<ng-container #viewContainerRef></ng-container>`,
  styleUrls: ['./windows-container.component.css'],
})
export class ElWindowsContainerComponent {

  // TODO static must be false as of Angular 9.0.0, issues/1514
  @ViewChild('viewContainerRef', { read: ViewContainerRef, static: true }) viewContainerRef: ViewContainerRef;
}
